import {career} from './career';
import {contact} from './contact';
import {footer} from './footer';
import {howDoWeDoIt} from './howDoWeDoIt';
import {indexHero} from './indexHero';
import {navigation} from './navigation';
import {references} from './references';
import {whatDoWeDo} from './whatDoWeDo';
import {whoAreWe} from './whoAreWe';

export const sk = {
	career,
	contact,
	footer,
	howDoWeDoIt,
	indexHero,
	navigation,
	references,
	whatDoWeDo,
	whoAreWe,
};
